<template>
  <Row class-name="base_week">
    <Col :span="7">
      <Select v-model="select1" class="prefix">
        <Option value="weeks">一周</Option>
        <Option value="month">一月</Option>
      </Select>
    </Col>
    <Col :span="17">
      <Select v-model="select2" class="suffix" @on-change="change_value">
        <Option
          v-for="(item, index) in options"
          :value="item.value"
          :key="`${index}-${item.value}`"
        >
          {{ item.label }}
        </Option>
      </Select>
    </Col>
  </Row>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    week: {
      type: Object,
      default: () => {}
    },
    month: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      select1: "weeks",
      select2: ""
    };
  },
  computed: {
    weekOpt: function() {
      let arr = [];
      for (let key in this.week) {
        arr.push({ value: key, label: this.week[key] });
      }
      return arr;
    },
    monthOpt: function() {
      let arr = [];
      for (let key in this.month) {
        arr.push({ value: key, label: this.month[key] });
      }
      return arr;
    },
    options: function() {
      if (this.select1 === "weeks") {
        return this.weekOpt.reverse();
      }
      if (this.select1 === "month") {
        return this.monthOpt.reverse();
      }
    }
  },
  methods: {
    change_value(val) {
      let params = getParams("a.week", val, "=");
      this.$emit("get", params, Boolean(val));
    }
  }
};
</script>

<style lang="less" scoped>
.base_week {
  /deep/ .prefix {
    .ivu-select-selection {
      background: #f8f8f9;
      border-right: 0;
      border-radius: 3px 0 0 3px !important;
    }
  }
  /deep/ .suffix {
    .ivu-select-selection {
      border-radius: 0 3px 3px 0 !important;
    }
  }
  &:visited {
    background: red;
  }
  &:hover {
    /deep/ .ivu-select-selection {
      border-color: #57a3f3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseWeek.vue